import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SectionDivider } from './Icons';
export const HookSection = () => {
  return <section className="py-8 px-4 md:px-8 bg-white" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-108">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-creamAlt text-brand-green mb-6" data-id="element-109">
            <MoonIcon className="w-8 h-8" data-id="element-110" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-charcoal leading-snug" data-id="element-111">
            ¿Te has despertado hoy a las 3:00 AM con el pijama empapado y la
            mente a mil por hora, solo para mirarte al espejo por la mañana y no
            reconocer a la mujer que tienes delante?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-brand-charcoal/90 leading-relaxed" data-id="element-112">
          <p data-id="element-113">
            Sientes que, de la noche a la mañana, tu cuerpo ha decidido jugar
            bajo sus propias reglas, acumulando grasa en zonas donde antes no
            existía y robándote la energía que necesitas para tu carrera y tu
            familia.
          </p>

          <div className="bg-brand-creamAlt p-6 rounded-xl border border-brand-gold/20 text-center mt-8" data-id="element-114">
            <p className="font-serif text-xl md:text-2xl font-semibold text-brand-green" data-id="element-115">
              No estás loca, no es falta de voluntad y, sobre todo, no tienes
              que resignarte.
            </p>
          </div>
        </motion.div>

        <SectionDivider data-id="element-116" />
      </div>
    </section>;
};